import React, { useContext } from "react";
import { Link } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";

import LibraryContext from "../libraryContext";
import { useGetSeachParam } from "../../useSearchParams";
import { useTranslation } from "react-i18next";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  listItem: {
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(4),
  },

  expandBtn: {
    padding: theme.spacing(1),
  },
});

export default function ContextItem({ context }) {
  const classes = useClasses(styles);
  const isSelected = Number(useGetSeachParam("c")) === context.contextId;
  const search = `?c=${context.contextId}`;
  const { handleQuery } = useContext(LibraryContext);
  const { t } = useTranslation();

  const handleClick = () =>
    handleQuery({ type: "navContextClick", payload: context.contextId });

  return (
    <ListItem
      button
      selected={isSelected}
      //component={Link}
      //to={{ pathname: `/library/contextId`, search }}
      onClick={handleClick}
      className={classes.listItem}
    >
      <ListItemIcon>
        <FolderSharedOutlinedIcon />
      </ListItemIcon>
      <ListItemText>
        <Typography variant={isSelected ? "subtitle2" : "body2"} noWrap>
          {context.name}
        </Typography>
        <Typography variant="body2" noWrap color="textSecondary">
          {!context.accepted ? t("library.pending") : ""}
        </Typography>
      </ListItemText>
    </ListItem>
  );
}
